export default "__VITE_ASSET__BUYStmtl__"